
import { toast } from 'react-toastify';

export function showErrorValidation(error: any){
    toast.error(`Não foi possivel finalizar a ação`);
}